export default __webpack_public_path__ + "static/play-bg-e202d6fa6f7857fc944396ad896c2705.png";